import React, { useState } from 'react';
import ListingCard from '../components/ListingCard';
import ListingDetail from '../components/ListingDetail';
import { useListings } from '../hooks/useFirestore';

const WA_DEFAULT = 'https://wa.me/971585338786?text=Hi%20I%20am%20interested%20in%20buying%20or%20selling%20an%20e-bike';
const BRANDS = ['Surron', 'Talaria', 'Kugoo', 'Zero', 'Segway', 'Other'];
const CONDITIONS = ['Brand New', 'Like New', 'Good', 'Fair'];
const CATEGORIES = [
  { id: 'surron', label: 'Surron' },
  { id: 'talaria', label: 'Talaria' },
  { id: 'dirt', label: 'Dirt Bikes' },
  { id: 'scooter', label: 'Scooters' },
  { id: 'used', label: 'Used' },
  { id: 'new', label: 'New Arrivals' },
];

export default function Buy({ defaultFilter }) {
  const { listings, loading } = useListings({ status: 'Listed' });
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [brand, setBrand] = useState('');
  const [condition, setCondition] = useState('');
  const [sort, setSort] = useState('newest');
  const [category, setCategory] = useState(defaultFilter || '');

  let filtered = listings.filter(l => {
    if (search && !l.name.toLowerCase().includes(search.toLowerCase()) && !l.brand.toLowerCase().includes(search.toLowerCase())) return false;
    if (brand && l.brand !== brand) return false;
    if (category && l.category !== category) return false;
    if (condition && l.condition !== condition) return false;
    return true;
  });

  if (sort === 'low') filtered.sort((a, b) => a.price - b.price);
  if (sort === 'high') filtered.sort((a, b) => b.price - a.price);

  const title = defaultFilter === 'used' ? 'Used E-Bikes Dubai' :
                defaultFilter === 'dirt' ? 'Electric Dirt Bikes Dubai' :
                'Buy E-Bikes in Dubai';

  return (
    <div className="fade-in" style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
      <h1 style={{ fontSize: 28, marginBottom: 8 }}>{title}</h1>
      <p style={{ color: 'var(--text-2)', marginBottom: 24 }}>{filtered.length} bikes available</p>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: '1 1 200px' }}>
          <input placeholder="Search bikes..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
          <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-3)' }}>🔍</span>
        </div>
        <select value={brand} onChange={e => setBrand(e.target.value)} style={{ flex: '0 0 150px' }}>
          <option value="">All Brands</option>
          {BRANDS.map(b => <option key={b} value={b}>{b}</option>)}
        </select>
        <select value={condition} onChange={e => setCondition(e.target.value)} style={{ flex: '0 0 150px' }}>
          <option value="">All Conditions</option>
          {CONDITIONS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={sort} onChange={e => setSort(e.target.value)} style={{ flex: '0 0 160px' }}>
          <option value="newest">Newest First</option>
          <option value="low">Price: Low → High</option>
          <option value="high">Price: High → Low</option>
        </select>
      </div>

      {/* Category tabs */}
      <div className="tab-bar" style={{ marginBottom: 24 }}>
        <button className={!category ? 'active' : ''} onClick={() => setCategory('')}>All</button>
        {CATEGORIES.map(c => (
          <button key={c.id} className={category === c.id ? 'active' : ''} onClick={() => setCategory(c.id)}>{c.label}</button>
        ))}
      </div>

      {/* Listings grid */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-2)' }}>Loading bikes...</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-2)' }}>
          <p style={{ fontSize: 16, marginBottom: 16 }}>No bikes found matching your filters.</p>
          <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className="btn-wa">💬 Ask us about availability</button>
          </a>
        </div>
      ) : (
        <div className="grid-3">
          {filtered.map(l => <ListingCard key={l.id} listing={l} onClick={setSelected} />)}
        </div>
      )}

      <div style={{ textAlign: 'center', padding: '48px 0' }}>
        <p style={{ color: 'var(--text-2)', marginBottom: 16 }}>Can't find what you're looking for?</p>
        <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <button className="btn-wa">💬 WhatsApp us your requirements</button>
        </a>
      </div>

      {selected && <ListingDetail listing={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
